var map = {
	"./20250112_193002.jpg": 5965,
	"./PXL_20231104_085514744.jpg": 1393,
	"./PXL_20231230_083928001.jpg": 2228,
	"./PXL_20240412_065028720-EFFECTS.jpg": 9660,
	"./PXL_20240512_144023198.jpg": 8420,
	"./PXL_20240602_114757640.MP~3.jpg": 7453,
	"./PXL_20240824_073021174.jpg": 7893,
	"./PXL_20241005_123938648.jpg": 6668,
	"./PXL_20241130_075717728.jpg": 3103,
	"./PXL_20241130_124011421.jpg": 1353,
	"./photo1.png": 4471,
	"./photo2.png": 7436,
	"./photo3.png": 9061,
	"./photo4.png": 7002,
	"./photo5.png": 6835
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8316;